import { Tag, type TagProps } from '@chakra-ui/react';

export type UiTagProps = TagProps;

export const UiTag = Tag;
